import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import { CommonMessages } from 'src/app/shared/messages/messages.enum';
import { MbService } from 'src/app/services/fbservice/mb.service';
import { OrderPipe } from 'ngx-order-pipe';
import { MasterService } from 'src/app/services/master/master.service';

import { ClientService } from 'src/app/services/clients/client.service';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';


@Component({
  selector: 'app-templatemanagement',
  templateUrl: './templatemanagement.component.html',
  styleUrls: ['./templatemanagement.component.css']
})
export class TemplatemanagementComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  today: number = Date.now();
  public postObj: any = [];
  getCompanyobj: any = [];
  currentUser;
  companyID = 0;
  selectedCompany: any = '';
  selectedmtype:any = '';
  fbord = "asc";
  fbColname = "post_name";
  fbPage = 1;
  fbLimit = 10;
  fbSkip = 0;
  fbTotal: number = 0;
  domainData: any=[];
  domain_id: any=0;
  journeyData: any[]=[];
  themeData: any[]=[];
  journey_id: any='';
  theme_id: any='';
  private readonly filterStateKey = 'tm_filter_state';
  constructor(
    private mb: MbService,
    private master: MasterService,
    private clientService: ClientService,
  ) { super(); }

  ngOnInit() {
    localStorage.removeItem("edit_post_id");
    localStorage.removeItem("post_edit_company_id");
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));
    const cameFromEditPage = sessionStorage.getItem('app_previous_url') === '/corporate/addnewtemplate';
    const restored = cameFromEditPage && this.restoreFilterState();
    if (!restored) this.searchText.nativeElement.value = '';
    if (this.currentUser.admin_customer_id != '0') {
      this.companyID = this.currentUser.admin_customer_id;


      this.selectedCompany = this.companyID;
      this.getPostManagement();
      this.getBusinessDomain();
      this.getJourneyList();
      if (restored && this.journey_id) this.getThemeListForJourney(this.journey_id);
      }
    //this.getPostManagement();


    if (this.currentUser.admin_customer_id == '0') {
      this.getCompany();
      if (restored && this.selectedCompany) {
        this.getPostManagement();
        this.getBusinessDomain();
        this.getJourneyList();
        if (this.journey_id) this.getThemeListForJourney(this.journey_id);
      }
    }
    this.PostManagementLogData();
  }

  ngOnDestroy() {
    const state = {
      selectedCompany: this.selectedCompany,
      selectedmtype: this.selectedmtype,
      domain_id: this.domain_id,
      journey_id: this.journey_id,
      theme_id: this.theme_id,
      fbPage: this.fbPage,
      fbColname: this.fbColname,
      fbord: this.fbord,
      searchTerm: this.searchText?.nativeElement?.value || ''
    };
    sessionStorage.setItem(this.filterStateKey, JSON.stringify(state));
  }

  private restoreFilterState(): boolean {
    const saved = sessionStorage.getItem(this.filterStateKey);
    if (!saved) return false;
    try {
      const state = JSON.parse(saved);
      this.selectedCompany = state.selectedCompany || '';
      this.selectedmtype = state.selectedmtype || '';
      this.domain_id = state.domain_id || 0;
      this.journey_id = state.journey_id || '';
      this.theme_id = state.theme_id || '';
      this.fbPage = state.fbPage || 1;
      this.fbColname = state.fbColname || 'post_name';
      this.fbord = state.fbord || 'asc';
      if (state.searchTerm) this.searchText.nativeElement.value = state.searchTerm;
      return true;
    } catch (e) {
      return false;
    }
  }

  private getThemeListForJourney(journeyId: any) {
    this.clientService.getAllThemeWithJourney(this.selectedCompany, journeyId, this.domain_id).subscribe(data => {
      this.themeData = data.status ? (data.rows || []) : [];
    }, error => {
      this.themeData = [];
    });
  }

  ngAfterViewInit() {
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.fbSkip = 0;
          this.fbPage = 1;
          this.ngxSpinnerService.show();
        }),
        switchMap(data =>
          this.mb.getPostBUData(this.selectedCompany, this.fbLimit, this.fbSkip, this.fbColname, this.fbord,this.selectedmtype, this.searchText.nativeElement.value, true,this.domain_id,this.journey_id,this.theme_id))
      )
      .subscribe(res => {
        if (res.status) {
          if (res.data.rows == null) { this.postObj = [] }
          else { this.postObj = res.data.rows }
          this.fbTotal = res.data.total;
        } else {
          this.postObj = [];
          this.fbTotal = 0;
        }
        this.ngxSpinnerService.hide();
      }, error => {
        this.postObj = [];
        this.fbTotal = 0;
        this.ngxSpinnerService.hide();
      });
  }

  setOrder(value: any) {
    this.fbColname = value;
    if (this.fbord == 'asc') {
      this.fbord = 'desc';
    } else {
      this.fbord = 'asc';
    }
    this.getPostManagement()
  }

  PostManagementLogData() {
    let pmLogs = {
      log_type: "Post Management View",
      log_name: "Post Management View",
      log_description: "Post Management View",
      moduleid: 1,
      moduleitemid: 7,
      per_id: 14
    }
    this.logs.addNewLogs(pmLogs).subscribe(data => {
      // console.log(data);
    }, error => {
      //  console.log(error);
    });
  }


  setValue(event) {
    let self = this;
    let url = event.target.src;
    if (url.indexOf("master_images") > 0) {
      url = url.substring(url.indexOf("master_images"), url.length)
      if (!this.isUrlValid(url)) {
        let awsUrl = self.master.getUrlfile(url);
        event.target.src = self.isUrlValid(awsUrl) ? awsUrl : '../../../assets/custom/images/broken.png';
      }
      else {
        // event.target.src = '../../../assets/custom/images/broken.png';
        event.target.src = '../../../assets/images/icons/video-play.svg';
      }
    } else {
      event.target.src = '../../../assets/custom/images/broken.png';
    }
    event.target.onerror = null;
  }

  isUrlValid(userInput) {
    return /(https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(userInput);
  }

  getPostManagement() {
    let searchTerm = this.searchText.nativeElement.value;
    this.fbSkip = (this.fbPage - 1) * this.fbLimit;

    if (this.selectedCompany !== "") {
      this.ngxSpinnerService.show();
      this.mb.getPostBUData(this.selectedCompany, this.fbLimit, this.fbSkip, this.fbColname, this.fbord,this.selectedmtype, searchTerm, true,this.domain_id,this.journey_id,this.theme_id).subscribe(data => {
        if (data.status) {

          if (data.data.rows == null) { this.postObj = [] }
          else {
            this.postObj = data.data.rows;


          }
          this.fbTotal = data.data.total;
          this.ngxSpinnerService.hide();

        } else {
          this.postObj = [];
          this.fbTotal = 0;
        }
      }, error => {
        // console.log(error);
        this.ngxSpinnerService.hide();
      });
    } else {
      this.postObj = [];
      this.fbTotal = 0;
      this.selectedCompany = "";
      this.ngxSpinnerService.hide();
    }
  }

  editPost(id) {
    localStorage.setItem("edit_post_id", id);
    localStorage.setItem("post_edit_company_id", this.selectedCompany);
    this.router.navigate(['/corporate/addnewtemplate']);
  }

  deletePost(id) {
    let obj = {
      id: id,
      company: this.selectedCompany
    }
    this.confirmationDialogService.confirm(CommonMessages.confirmationTitle, 'Are you sure you want to Delete?', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.mb.delPost(obj).subscribe(data => {
            if (data.status) {
              this.getPostManagement();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
              this.ngxSpinnerService.hide();
            } else {
              this.ngxSpinnerService.hide();
            }
          }, error => {
            this.toastrService.error(error.message);
          });
        }
      }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }
  updateStatus(event, id) {
    event.preventDefault();
    let obj = this.postObj.find(element => {
      // console.log(element.get_master_company_type.company_type_id)
      if (element.message_id === id) {
        return true;
      }
    });
    obj = obj;
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to change the status To' + ((obj.isactive) ? ' In Active' : ' Active'), 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          const obj2 = {
            status: !obj.isactive,
            message_id: id,
            company: Number(this.selectedCompany)
          }
          this.mb.updateTemplateStatus(obj2).subscribe(data => {
            this.toastrService.success("Status Updated Successfully")
            this.getPostManagement();
          });
          this.ngxSpinnerService.hide();
        } else {
          this.ngxSpinnerService.hide();
        }
      }).catch(() => {
        //console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });
  }

  getCompany() {
    let self = this;
    this.clientService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self, (id) => { self.getCompanyThemes(id); });

      this.ngxSpinnerService.hide();
    }, error => {
      // console.log(error);
    });
  }
  getBusinessDomain(){
    let self = this;
    this.master.getBusinessDomain(100,0,this.selectedCompany).subscribe(data => {
      this.ngxSpinnerService.hide();
      self.domainData = data.data.rows;
    }, error => {
      this.domainData=[]
      this.ngxSpinnerService.hide();
    });
  }
  getCompanyThemes(id) {
    this.ngxSpinnerService.show();
    if (id != '' && id !== '0') {
      this.selectedCompany = id;
      this.domain_id=0
      this.journey_id='';
      this.theme_id='';
      this.themeData=[];
      this.getPostManagement();
      this.getBusinessDomain();
      this.getJourneyList();
    } else {
      this.selectedCompany = id;
      this.domain_id=0;
      this.domainData=[];
      this.journey_id='';
      this.theme_id='';
      this.journeyData=[];
      this.themeData=[];
      this.ngxSpinnerService.hide();
    }
  }
  getDomainList(id:any){
    this.ngxSpinnerService.show();
      this.domain_id = id;
      this.fbPage = 1;
      this.fbLimit = 10;
      this.fbSkip = 0;
      this.getPostManagement();
  }
  getJourneyList(){
    let self = this;
    this.clientService.getAllJourney(this.selectedCompany).subscribe(data => {
      self.journeyData = data.status ? (data.rows || []) : [];
    }, error => {
      self.journeyData = [];
    });
  }
  getJourneyFilterList(id:any){
    this.journey_id = id;
    this.theme_id = '';
    this.themeData = [];
    this.fbPage = 1;
    this.fbSkip = 0;
    if(id) {
      this.ngxSpinnerService.show();
      this.clientService.getAllThemeWithJourney(this.selectedCompany, id, this.domain_id).subscribe(data => {
        this.themeData = data.status ? (data.rows || []) : [];
        this.ngxSpinnerService.hide();
      }, error => {
        this.themeData = [];
        this.ngxSpinnerService.hide();
      });
    }
    this.getPostManagement();
  }
  getThemeFilterList(id:any){
    this.theme_id = id;
    this.fbPage = 1;
    this.fbSkip = 0;
    this.getPostManagement();
  }
}
